import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import LabsPanel from "../components/LabsPanel";
import { Button } from "../components/ui/button";
import { ChevronLeft } from "lucide-react";

const LabsManager = () => {
  return (
    <div className="min-h-screen bg-background" data-testid="labs-manager">
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Link to="/admin" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-6">
          <ChevronLeft className="w-4 h-4" /> Administration
        </Link>
        <LabsPanel />
      </div>
    </div>
  );
};

export default LabsManager;
